import { PaymentStatusResponse, usePayCheckoutMutation } from "../../api/pos-api";
import { PaymentType } from "../../api/types";
import { useState } from "react";
import { useAppDispatch } from "../../store";
import { setPaymentArgs, togglePaymentModal } from "../../store/slices/modalsSlice";
import { CheckoutResponse, CreateCartResponse, useCreateCartMutation } from "../../api/hitl-api";
import { useParams } from "react-router-dom";
import { MakePaymentFn, PaymentContextValue } from "./payment-context";
import { posApiInstance } from "../../api/axios/api-instances";

export const useSkuInBoxPayment = (
  lines: CheckoutResponse["result"]["lines"] | undefined
): PaymentContextValue => {
  const dispatch = useAppDispatch();
  const [payCheckout] = usePayCheckoutMutation(undefined);
  const [createCart] = useCreateCartMutation();
  const [loading, setLoading] = useState<PaymentType | null>(null);
  const { zoneId = "", key = "" } = useParams();

  const handlePayCheckout: MakePaymentFn = async ({ type, checkin, onCheckoutCreated }) => {
    if (!lines) {
      throw Error("checkout lines doesn't exist");
    }

    setLoading(type);

    let rmsCart: CreateCartResponse | null = null;

    try {
      rmsCart = await createCart({
        checkoutId: key,
      }).unwrap();
    } catch (err) {
      return Promise.reject(err);
    } finally {
      setLoading(null);
    }

    if (!rmsCart) return;

    dispatch(
      setPaymentArgs({
        checkoutId: rmsCart.result,
        type,
      })
    );
    onCheckoutCreated?.(rmsCart.result);

    return payCheckout({
      checkout_id: rmsCart.result,
      payment_type: type,
      zone_id: zoneId,
      checkin,
    })
      .unwrap()
      .finally(() => {
        setLoading(null);
      });
  };

  const makePayment: MakePaymentFn = ({ type, checkin, onCheckoutCreated }) => {
    dispatch(togglePaymentModal({ open: true }));
    dispatch(
      setPaymentArgs({
        checkoutId: null,
        type,
      })
    );

    return handlePayCheckout({ type, checkin, onCheckoutCreated });
  };

  const fetchPaymentStatus = (checkoutId: string) => {
    return posApiInstance.get<PaymentStatusResponse>(`/sku_in_box/checkout/${checkoutId}/status`);
  };

  return {
    makePayment,
    loading,
    fetchPaymentStatus,
  };
};
